import { Controller } from 'stimulus';
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
import { Chart } from 'chart.js';

let chart = null;

export default class extends Controller {
  chart = null

  static targets = [ "container", "canvas", "legends" ]
  static values = {
    url: String,
    type: String,
    data: Object,
    options: Object
  }

  connect() {
    console.log(this.urlValue)

    // The chart.js instance
    chart = new Chart(this.canvasTarget.getContext('2d'), {
      type: this.typeValue || 'line',
      data: this.chartData,
      options: this.optionsValue
    })

    this.update()
  }

  disconnect () {
    chart.destroy()
    chart = undefined
  }

  // Bind an action on this method
  update () {
    fetch(this.urlValue).
    then(response => response.json()).
    then(data =>
        {
          // console.log(data)

          chart.data = data
          chart.update()

          this.containerTarget.classList.remove('animate-pulse')

          if (this.hasLegendsTarget) {
            let legends = ''
            data.datasets.map(function (row) {
              // console.log(row.label)
              // console.log(row.elementColor)

              legends = legends +
                  `<div class="pl-3 inline-flex items-center">
                     <div class="w-3.5 h-3.5 rounded" style="background-color: ${row.elementColor}"></div>
                     <span class="pl-1 sm:text-sm text-gray-700">${row.label}</span>
                   </div>`
            });

            this.legendsTarget.innerHTML = legends
          }
        }
    )
    // Catch any errors
    .catch(error => console.log(error));
  }

  get chartData () {
    return this.dataValue
  }
}
